import axios from 'axios';
import Forms from '../forms/form';
import Bouncer from 'formbouncerjs/src/js/bouncer/bouncer';
import { loadHcaptcha } from '../app';

export default class Newsletter {
    constructor() {
        this.section = document.querySelector('.section-newsletter');
        this.form = this.section.querySelector('#formNewsletter');
        this.formFields = this.form.querySelectorAll('input, select, textarea');
        this.successMessage = this.section.querySelector('.success-form');
        this.errorMessage = this.section.querySelector('.error-form');
        this.btnSubmit = this.form.querySelector('button');
        this.hcaptchaWidgetId = null; // Para armazenar o ID do widget hCaptcha

        this.ready();
        this.initHcaptcha();
    }

    ready() {
        new Bouncer(`#formNewsletter`, {
            fieldClass: 'error-field',
            disableSubmit: true,
            ...Forms.wrongMessages(),
        });

        this.form.addEventListener(
            'bouncerFormValid',
            (event) => {
                event.preventDefault();
                if (event.target.id === this.form.id) {
                    // Acione o hCaptcha invisível
                    hcaptcha.execute(this.hcaptchaWidgetId);
                }
            },
            false
        );
    }

    initHcaptcha() {
        this.formFields.forEach((field) => {
            field.addEventListener('focus', window.loadHCaptcha);
        });

        // Configura o hCaptcha após carregar
        window.onHCaptchaLoad = () => {
            const siteKey = document.querySelector('meta[name="rv3:sitekey"]')?.getAttribute('content');
            if (!siteKey) {
                console.error('hCaptcha siteKey não encontrada.');
                return;
            }

            // Renderiza o hCaptcha invisível e armazena o ID do widget
            this.hcaptchaWidgetId = hcaptcha.render('hcaptcha-container', {
                sitekey: siteKey,
                size: 'invisible',
                callback: (token) => this.hcaptchaCallback(token), // Chama o método da classe
            });
        };
    }

    hcaptchaCallback(token) {
        if (token) {
            // Token gerado, continue com o envio do formulário
            this.sendFormNewsletterAjax(this.form);
        } else {
            console.error('hCaptcha não gerou um token.');
            this.errorMessage.classList.remove('hidden');
            this.btnSubmit.disabled = false;
        }
    }

    sendFormNewsletterAjax(form) {
        this.btnSubmit.disabled = true;

        const hcaptchaResponse = this.section.querySelector('textarea[name="h-captcha-response"]').value;

        if (!hcaptchaResponse) {
            console.log('hCaptcha token not found');
            this.btnSubmit.disabled = false;
            return;
        }

        const dataForm = new FormData(form);
        dataForm.append('h-captcha-response', hcaptchaResponse);

        if (this.form.querySelector('#privacy').checked) {
            dataForm.set('privacy', 1);
        } else {
            dataForm.set('privacy', 0);
        }

        axios({
            method: 'POST',
            url: window.origin + '/wp-json/custom-api/validate-hcaptcha',
            data: dataForm,
            headers: { 'Content-Type': 'multipart/form-data' },
        })
            .then((response) => {
                if (response.data.success) {
                    form.reset();
                    this.btnSubmit.disabled = false;
                    this.successMessage.classList.remove('hidden');
                    this.scrollToSection();
                } else {
                    throw new Error('hCaptcha validation failed');
                }
            })
            .catch(() => {
                console.log('Erro na validação do hCaptcha ou no envio do formulário.');
                this.successMessage.classList.add('hidden');
                this.errorMessage.classList.remove('hidden');
                this.btnSubmit.disabled = false;
            });
    }

    scrollToSection() {
        const headerOffset = 120;
        const elementPosition = this.section.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
        });
    }
}

if (document.querySelector('.section-newsletter')) {
    new Newsletter();
}
